import { Route, Routes } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { hasAdminAccess, hasUserPortalAccess } from "../reducers/authSlice";
import UnAuthorizedRoutes from "./UnAuthorizedRoutes";

import NonAdminRoutes from "./NonAdminRoutes";
import AdminRoutes from "./AdminRoutes";
import CustomAdminRoute from "./CustomAdminRoute";

const CustomRoutes = () => {
  const isAdmin = useAppSelector(hasAdminAccess);
  const isAuthorizedUser = useAppSelector(hasUserPortalAccess);

  return (
    <Routes>
      {isAuthorizedUser ? (
        <>
          {NonAdminRoutes}
          <Route element={<CustomAdminRoute isAdmin={isAdmin} />}>
            {AdminRoutes}
          </Route>
        </>
      ) : (
        <>{UnAuthorizedRoutes}</>
      )}
    </Routes>
  );
};

export default CustomRoutes;
